<script setup lang="ts">
const items = [
  {
    title: 'Insight Logistik Otomatis',
    description:
      'Sistem memberikan notifikasi performa SLA, keterlambatan, atau anomali pengiriman secara otomatis.',
    icon: 'material-symbols:local-shipping-outline'
  },
  {
    title: 'Klaim Asuransi & Retur',
    description:
      'Proses klaim cepat dan transparan, seluruh dokumentasi tersimpan otomatis di dashboard.',
    icon: 'ka-icon:package-claim'
  },
  {
    title: 'Terintegrasi dengan Semua Solusi KiriminAja',
    description:
      'Dapat diakses dari API, Plugin, maupun Aplikasi Mobile tanpa sinkronisasi manual.',
    icon: 'material-symbols:dashboard-outline'
  },
  {
    title: 'Kirim Paket Massal',
    description:
      'Kirim ratusan pesanan lintas produk dan ekspedisi hanya dalam satu langkah. Efisien & akurat.',
    icon: 'material-symbols:quick-reorder-outline'
  },
  {
    title: 'COD Cair Cepat',
    description:
      'Dana COD cair di hari yang sama. Menjaga cashflow tetap lancar, tanpa proses manual.',
    icon: 'material-symbols:electric-bolt-outline'
  },
  {
    title: 'KA Poin',
    description:
      'Program loyalitas berbasis volume pengiriman: tukar poin dengan hadiah menarik tanpa undian.',
    icon: 'ka-icon:ka-poin'
  },
  {
    title: 'COD Advance',
    description:
      'Akses hingga 50% dana COD bahkan sebelum paket diterima pelanggan. Solusi finansial untuk volume besar.',
    icon: 'ic:outline-payments'
  },
  {
    title: 'KA Kredit',
    description:
      'Pembayaran Non-COD & ROMS instan tanpa approval manual, cocok untuk tim operasional cepat.',
    icon: 'material-symbols:credit-score-outline'
  },
  {
    title: 'Undelivery Aset',
    description:
      'Sistem notifikasi otomatis untuk paket gagal kirim. Cegah retur dan percepat tindak lanjut operasional.',
    icon: 'hugeicons:delivery-return-01'
  },
  {
    title: 'Manajemen Staff',
    description:
      'Role-based access untuk kontrol penuh aktivitas tim operasional & keuangan.',
    icon: 'material-symbols:groups-outline'
  },
  {
    title: 'Whatsapp Follow-up',
    description:
      'Komunikasi otomatis kepada pelanggan melalui WhatsApp untuk update status pengiriman.',
    icon: 'ic:baseline-whatsapp'
  },
  {
    title: 'Laporan & Analitik Lengkap',
    description:
      'Semua data pengiriman dan keuangan terpusat dalam satu platform, mendukung analisis berbasis data.',
    icon: 'material-symbols:analytics-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiContainer class="py-12 flex flex-col gap-12">
    <UiSectionTitle
      title="Keunggulan Dashboard KiriminAja"
      description="Lebih dari sekadar laporan pengiriman — Dashboard ini dirancang untuk pertumbuhan bisnis jangka panjang."
      title-as="h2"
    />
    <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex items-start gap-3"
      >
        <div
          class="p-2 rounded-full bg-primary-container flex-none text-primary"
        >
          <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
        </div>
        <div class="flex-1 flex flex-col gap-2">
          <p class="text-sm lg:text-xl font-bold lg:font-semibold">
            {{ item.title }}
          </p>
          <p class="text-sm lg:text-base text-outline">
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
  </UiContainer>
</template>
